module.exports = __webpack_public_path__ + "static/gallery-10@2x-ac4a0cc147187cc49e368e4703726572.jpg";